import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAsync } from 'react-use'

import { Form as AntdForm, Card, Row, Col, Table, Modal, Input, Select, Button, Tag, Space, Skeleton } from 'antd'
import { SearchOutlined, PrinterOutlined, EyeOutlined, DeleteOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'

import { useAuth } from '../../contexts/AuthContextProvider'
import { useLayoutContext } from '../../contexts/LayoutContextProvider'
import { genCsv } from '../../utils/csv'
import { search } from '../../utils/search'
import { paymentObj } from '../../const/fee'
// import { isAllowed } from '../../route/roles'

const List = () => {
  const navigate = useNavigate()
  const { db } = useAuth()
  const { getPageNo, onPageChange, getSearch, setSearch } = useLayoutContext()

  // const [updateCount, setUpdateCount] = useState(0)
  const [initValue, setInitValue] = useState([])
  const [value, setValue] = useState([])
  const [qsVisible, setQsVisible] = useState(false)
  const [qs, setQs] = useState({})
  const [tags, setTags] = useState([])

  const [searchForm] = AntdForm.useForm()

  const { loading } = useAsync(async () => {
    const snap = await db.collection('/users').where('disabled', '==', false).where('payment', 'in', ['payment', 'partial', 'none', 'return']).get()
    let data = snap.docs.map(doc => {
      const d = doc.data()
      return {
        ...d,
        id: doc.id,
        scn: d?.scn ?? ''
      }
    })
    data = data.sort((x, y) => x.payment.localeCompare(y.payment))

    const q = getSearch('fees')
    setQs(q || {})
    setInitValue(data)
  }, [])

  useEffect(() => {
    const tagList = Object.keys(qs).reduce((acc, o) => {
      return (!qs[o]) ? acc : [...acc, {
        key: o,
        value: (o === 'payment') ? paymentObj[qs[o]]?.name : qs[o],
        label: {
          scn: 'รหัสนักเรียน',
          firstname: 'ชื่อ',
          lastname: 'นามสกุล',
          payment: 'สถานะ'
        }[o]
      }]
    }, [])
    setTags(tagList)
    const data = search(initValue, qs)
    setValue(data)
  }, [initValue, qs])

  const handleClose = (key) => {
    const newQs = {
      ...qs,
      [key]: null
    }
    setQs(newQs)
    setSearch('fees', newQs)
    searchForm.setFieldsValue(newQs)
  }

  // const handleDelete = async (row) => {
  //   try {
  //     const snap = await db.collection('/fees').where('uid', '==', row.id).get()
  //     for await (const doc of (snap?.docs ?? [])) {
  //       await db.collection('/fees').doc(doc.id).delete()
  //     }

  //     await db.collection('/users').doc(row.id).update({
  //       payment: firebaseApp.firestore.FieldValue.delete()
  //     })
  //     setUpdateCount(updateCount + 1)
  //     return Promise.resolve()
  //   } catch (error) {
  //     return Promise.reject(error)
  //   }
  // }

  const download = async (data) => {
    const list = data.map((o) => ({
      'รหัสนักเรียน': o?.scn ?? '',
      'ชื่อ': o?.firstname ?? '',
      'นามสกุล': o?.lastname ?? '',
      'สถานะการชำระเงิน': paymentObj[o?.payment]?.name ?? ''
    }))
    try {
      await genCsv('fee_list', list)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  const columns = [
    {
      title: 'รหัสนักเรียน',
      dataIndex: 'scn',
      width: 120
    },
    {
      title: 'ชื่อ',
      dataIndex: 'firstname',
      width: 150
    },
    {
      title: 'นามสกุล',
      dataIndex: 'lastname',
      width: 150
    },
    {
      title: 'สถานะการชำระเงิน',
      dataIndex: 'payment',
      width: 120,
      align: 'center',
      render: data => (
        <span style={{ color: paymentObj[data]?.color ?? '' }}>{paymentObj[data]?.name ?? ''}</span>
      )
    },
    {
      title: 'เครื่องมือ',
      dataIndex: 'Operation',
      width: 175,
      render: (_, row) => (
        <div>
          <Button
            type='link'
            style={{ marginRight: '8px' }}
            icon={<EyeOutlined style={{ fontSize: 18 }} />}
            onClick={() => {
              navigate(`/admin/fees/${row.id}/view`)
            }}
          ></Button>
          {/* {(isAllowed(role, 'delete', 'fees')) && (
            <Popconfirm
              title='Are you sure to delete this student fee?'
              onConfirm={() => handleDelete(row)}
              okText='Yes'
              cancelText='No'
            >
              <Button
                type='link'
                style={{ marginRight: '8px' }}
                danger
                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
              ></Button>
            </Popconfirm>
          )} */}
        </div>
      )
    }
  ]

  if (loading) return <Skeleton></Skeleton>
  return (
    <Card style={{ minHeight: '100%' }}>
      <Row>
        <Col flex='auto'>
          <div style={{ fontSize: 24 }}>
            ค่าลงทะเบียนเรียน
          </div>
          <div style={{ marginTop: 12 }}>
            {tags.map((o) => (
              <Tag
                key={o.key}
                closable
                onClose={() => handleClose(o.key)}
              >
                {o.label}: {o.value}
              </Tag>
            ))}
          </div>
        </Col>
        <Col flex='300px'>
          <div style={{ float: 'right', fontSize: 14 }}>
            {/* {(isAllowed(role, 'create', 'fees')) && (
              <div>
                <Button
                  type='primary'
                  icon={<PlusOutlined style={{ fontSize: 14 }} />}
                  onClick={() => {
                    navigate('/admin/fees/create')
                  }}
                >
                  สร้างบันทึก
                </Button>
              </div>
            )} */}
            <div style={{ float: 'right', margin: '8px 0 16px 0' }}>
              <Button
                icon={<SearchOutlined />}
                style={{ margin: '0 8px' }}
                onClick={() => {
                  setQsVisible(true)
                }}
              ></Button>
              <Button
                icon={<PrinterOutlined />}
                onClick={() => {
                  download(value)
                }}
              ></Button>
            </div>
          </div>
        </Col>
      </Row >
      <Table
        bordered
        rowKey='id'
        style={{ overflowX: 'auto' }}
        columns={columns}
        dataSource={value}
        pagination={{
          total: value.length,
          current: getPageNo('fees'),
          onChange(page) {
            onPageChange('fees', page)
          }
        }}
      />
      <Modal
        forceRender
        open={qsVisible}
        title={
          <div style={{ padding: '16px 24px', fontWeight: 'bold', fontSize: '18px', lineHeight: '23px', backgroundColor: '#228B90', color: '#F6F6F6', borderRadius: '5px 5px 0px 0px' }}>
            ค้นหา
          </div>
        }
        width='50%'
        closable={false}
        footer={
          <Row justify='center'>
            <Space align='center'>
              <Col>
                <Button
                  type='secondary'
                  size='medium'
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    const empty = {
                      scn: null,
                      firstname: null,
                      lastname: null,
                      payment: null
                    }
                    setQs(empty)
                    setSearch('fees', empty)
                    searchForm.setFieldsValue(empty)
                  }}
                >
                  Clear Data
                </Button>
              </Col>
              <Col>
                <Button
                  size='medium'
                  style={{ color: '#FFF', backgroundColor: '#EE7930' }} icon={<CloseOutlined />}
                  onClick={() => {
                    setQsVisible(false)
                  }}
                >
                  ยกเลิก
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  size='medium'
                  icon={<CheckOutlined />}
                  onClick={() => {
                    const data = searchForm.getFieldsValue()
                    setQs(data)
                    setSearch('fees', data)
                    setQsVisible(false)
                  }}
                >
                  ยืนยัน
                </Button>
              </Col>
            </Space>
          </Row>
        }
      >
        <AntdForm
          layout='vertical'
          initialValues={qs}
          style={{ margin: '8px 32px' }}
          form={searchForm}
          name='searchForm'
        >
          <Row gutter={[24, 24]}>
            <Col span={12}>
              <AntdForm.Item name='scn' label='รหัสนักเรียน' >
                <Input placeholder='รหัสนักเรียน' />
              </AntdForm.Item>
            </Col>
            <Col span={12}>
              <AntdForm.Item name='payment' label='สถานะ' >
                <Select placeholder='เลือก' >
                  {((Object.keys(paymentObj)).map((o) => (
                    <Select.Option key={o} value={o}>{paymentObj[o].name}</Select.Option>
                  )))}
                </Select>
              </AntdForm.Item>
            </Col>
          </Row>
          <Row gutter={[24, 24]}>
            <Col span={12}>
              <AntdForm.Item name='firstname' label='ชื่อ' >
                <Input placeholder='ชื่อ' />
              </AntdForm.Item>
            </Col>
            <Col span={12}>
              <AntdForm.Item name='lastname' label='นามสกุล' >
                <Input placeholder='นามสกุล' />
              </AntdForm.Item>
            </Col>
          </Row>
        </AntdForm>
      </Modal>
    </Card >
  )
}

export default List
